<template>
  <div class="container-fluid">
    <div data-widget-group="group1">
      <ol class="breadcrumb">
        <li class="active">
          <router-link to="/admin">Dashboard</router-link>
        </li>
        <li class="active">Organization Profile</li>
      </ol>

      <div class="panel-body locationform">
        <form @submit.prevent="handleUpdateProfile" autocomplete="off">
          <div class="row">
            <div v-if="message" class="alert-danger alert visibility" role="alert">
              {{ message }}
            </div>
            <div v-if="SuccessMessage" class="alert-success alert alert-info visibility" role="alert">
              {{ SuccessMessage }}
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label>Organization Name</label>
                <input
                  v-model="orgprofile.name"
                  v-validate="'required'"
                  type="text"
                  class="form-control"
                  name="OrganizationName"
                  placeholder="organization name"
                  :readonly="writePermission"
                />
                <span v-if="errors.has('OrganizationName')">
                  {{ errors.first('OrganizationName') }}
                </span>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label>Address</label>
                <input
                  v-model="orgprofile.address"
                  v-validate="'required'"
                  type="text"
                  class="form-control"
                  name="address"
                  placeholder="address"
                  :readonly="writePermission"
                />
                <span v-if="errors.has('address')">
                  {{ errors.first('address') }}
                </span>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label>Website</label>
                <input
                  v-model="orgprofile.website"
                  v-validate="'required'"
                  type="text"
                  class="form-control"
                  name="Website"
                  placeholder="url"
                  :readonly="writePermission"
                />
                <span v-if="errors.has('Website')">
                  {{ errors.first('Website') }}
                </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label>Country</label>
                <search-select
                  @selectedData="getCountrySelected"
                  :preSelect="this.orgprofile.country_data"
                  :labelName="'Country'"
                  :remoteControl="'kspgAPI/commonData/country'"
                ></search-select>
                <span v-if="errors.has('country')">
                  {{ errors.first('country') }}
                </span>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label>State</label>
                <search-select
                  @selectedData="getStateSelected"
                  :preSelect="this.orgprofile.state_data"
                  :labelName="'State'"
                  :remoteControl="'kspgAPI/commonData/state'"
                ></search-select>
                <span v-if="errors.has('state')">
                  {{ errors.first('state') }}
                </span>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label>City</label>
                <search-select
                  @selectedData="getCitySelected"
                  :preSelect="this.orgprofile.city_data"
                  :labelName="'City'"
                  :remoteControl="'kspgAPI/commonData/cities'"
                ></search-select>
                <span v-if="errors.has('city')">
                  {{ errors.first('city') }}
                </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label>Pin Code</label>
                <input
                  v-model="orgprofile.pincode"
                  type="text"
                  class="form-control"
                  name="pincode"
                  placeholder="Pin Code"
                  :readonly="writePermission"
                />
                <span v-if="errors.has('pincode')">
                  {{ errors.first('pincode') }}
                </span>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label>Contact Number</label>
                <input
                  v-model="orgprofile.toll_free_no"
                  v-validate="'required'"
                  type="text"
                  class="form-control"
                  name="toll_free_no"
                  placeholder="Contact Number"
                  :readonly="writePermission"
                />
                <span v-if="errors.has('toll_free_no')">
                  {{ errors.first('toll_free_no') }}
                </span>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label>GST Number</label>
                <input
                  v-model="orgprofile.gstnumber"
                  v-validate="'required'"
                  type="text"
                  class="form-control"
                  name="gstnumber"
                  placeholder="gst number"
                  :readonly="writePermission"
                />
                <span v-if="errors.has('gstnumber')">
                  {{ errors.first('gstnumber') }}
                </span>
              </div>
            </div>
          </div>
          <div class="row" v-if="!writePermission">
            <div class="col-sm-4">
              <file-upload
                :labelName="'Upload Logo'"
                @imageUploadData="LogoUpload"
                
              ></file-upload>
            </div>
          </div>
          <div class="row" v-if="!writePermission">
            <div class="col-sm-3 col-sm-offset-9">
              <button class="btn-default btn">Cancel</button>
              <button
                class="btn-raised btn-primary btn fixcolorAs"
                :disabled="loading"
              >
                <span>Save</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div id="externalScript"></div>
  </div>
</template>
<script>
import fileUpload from './components/file_upload';
import searchSelect from './components/Select2Search';
import commonServices from '../services/common-services';
import UserService from '../services/user.service';
export default {
  name: 'organisationProfile',
  data() {
    return {
      loading: false,
      SuccessMessage: '',
      message: '',
      orgprofile: {
        entity_id: '',
        name: '',
        pincode: '',
        address: '',
        state: '',
        state_data: '',
        city: '',
        city_data: '',
        country: '',
        country_data: '',
        toll_free_no: '',
        website: '',
        gstnumber: '',
        auth_user_pic: '',
      },
    };
  },
  components: { fileUpload, searchSelect },
  beforeCreate() {
    this.$store.commit('SET_LAYOUT', 'app-layout');
  },
  computed:{
    writePermission(){
      return !this.$can('Edit','OrganisationSetup::Organisation Profile')
    }
  },
  methods: {
    getCitySelected(cityName) {
      if (cityName) {
        this.orgprofile.city = cityName.code;
        this.orgprofile.city_data = cityName;
        /* Remove Validation */
        //this.errors.clear();
        this.errors.remove('city');
      } else {
        this.orgprofile.city = '';
        this.orgprofile.city_data = {};
        this.errors.add({
          field: 'city',
          msg: 'Please Select City',
        });
      }
    },
    getStateSelected(stateName) {
      if (stateName) {
        this.orgprofile.state = stateName.code;
        this.orgprofile.state_data = stateName;
        /* Remove Validation */
        this.errors.remove('state');
      } else {
        this.orgprofile.state = '';
        this.orgprofile.state_data = {};
        this.errors.add({
          field: 'state',
          msg: 'Please Select State',
        });
      }
    },
    getCountrySelected(CountryName) {
      if (CountryName) {
        this.orgprofile.country = CountryName.code;
        this.orgprofile.country_data = CountryName;
        /* Remove Validation */
        this.errors.remove('country');
      } else {
        this.orgprofile.country = '';
        this.orgprofile.country_data = {};
        this.errors.add({
          field: 'country',
          msg: 'Please Select Country',
        });
      }
    },
    LogoUpload(imageData) {
      this.auth_user_pic = imageData;
    },
    getOrgProfile() {
      commonServices
        .get('Auth/profile', {})
        .then((response) => {
          console.log(response.data);
          const { orgprofile } = response.data.data;
          this.orgprofile = orgprofile;
        })
        .catch((e) => {
           if(e.response.data.error == "Invalid API key "){
             this.$router.push({ name: 'login'});
          }
        });
    },
    handleUpdateProfile(e) {
      this.$validator.validateAll().then((res) => {
        /*Check custome credentials */
        if (this.orgprofile.city == '') {
          this.errors.add({
            field: 'city',
            msg: 'Please Select City',
          });
          res = false;
        }

        if (this.orgprofile.state == '') {
          this.errors.add({
            field: 'state',
            msg: 'Please Select State',
          });
          res = false;
        }

        if (this.orgprofile.country == '') {
          this.errors.add({
            field: 'country',
            msg: 'Please Select Country',
          });
          res = false;
        }

        if (!res) {
          // handle input errors.
          return;
        }
        /*Submit profiiile Information */

        UserService.postMetod(
          'kspgAPI/Organisation/update',
          this.orgprofile
        ).then(
          (response) => {
            this.loading = false;
            // on success reset values
            if (response.data.status) {
              this.SuccessMessage = response.data.message;
            } else {
              this.message = response.data.message;
            }
          },
          (error) => {
            this.loading = false;

            this.message =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        );

        // Hide Messages
        setTimeout(
          () => ((this.message = false), (this.SuccessMessage = false)),
          5000
        );
      });
    },
  },
  mounted() {
    this.getOrgProfile();
  },
};
</script>
<style scoped>
.visibility {
  visibility:visible !important;
}
</style>